<article
  class="cads-main-template"
  [class.cads-main-template--compact]="compactCentered()"
  [class.cads-main-template--edge-to-edge]="config().edgeToEdge === true"
  [ngStyle]="articleStyles()"
>
  <header class="cads-main-template__header" [hidden]="!showHeaderRegion()">
    <div class="cads-main-template__inner cads-main-template__header-bar">
      @if (showBuiltInBack()) {
        <div class="cads-main-template__header-back">
          <button
            type="button"
            class="cads-main-template__back"
            [disabled]="backDisabled()"
            (click)="_onBackTap()"
          >
            <span class="cads-main-template__back-icon" aria-hidden="true">
              <cads-icon-view-bit [config]="backIconConfig()" />
            </span>
            <span class="cads-main-template__back-label">{{ backLabel() }}</span>
          </button>
        </div>
      }
      @if (headerTitle(); as title) {
        <h1 class="cads-main-template__header-title">{{ title }}</h1>
      }
      <div class="cads-main-template__header-slot" [hidden]="!effectiveShowHeaderSlot()">
        <ng-content select="[cads-main-header]"></ng-content>
      </div>
    </div>
  </header>

  <div
    #mainScroll
    class="cads-main-template__main"
    [class.cads-main-template__main--centered]="compactCentered()"
  >
    <div class="cads-main-template__inner cads-main-template__inner--main">
      <div class="cads-main-template__intro" [hidden]="!showIntroRegion()">
        <div class="cads-main-template__hero" [hidden]="!showHeroRegion()">
          <ng-content select="[cads-main-hero]"></ng-content>
        </div>
        @if (headingForTemplate(); as hc) {
          <div
            class="cads-main-template__heading"
            [class.cads-main-template__heading--title-in-header]="headerTitle() != null"
          >
            <cads-heading-detail-bit [config]="hc" />
          </div>
        }
      </div>

      <section class="cads-main-template__body" [hidden]="!effectiveShowBody()">
        <ng-content select="[cads-main-body]"></ng-content>
      </section>
    </div>
  </div>

  <footer class="cads-main-template__footer" [hidden]="!effectiveShowFooter()">
    <div class="cads-main-template__inner cads-main-template__inner--footer">
      @if (useConfigFooter() && showFooterConfirmation()) {
        <div class="cads-main-template__footer-confirm">
          <label class="cads-main-template__footer-confirm-label">
            <input
              type="checkbox"
              class="cads-main-template__footer-confirm-input"
              [checked]="footerConfirmationChecked()"
              (change)="_onFooterConfirmationChange($event)"
            />
            <span class="cads-main-template__footer-confirm-text">{{ footerConfirmationLabel() }}</span>
          </label>
        </div>
      }
      <div class="cads-main-template__footer-actions">
        @if (useConfigFooter()) {
          @if (secondaryCta()) {
            <cads-app-button [config]="secondaryButtonConfig()" (tapped)="_onSecondaryTap()" />
          }
          @if (primaryCta()) {
            <cads-app-button [config]="primaryButtonConfig()" (tapped)="_onPrimaryTap()" />
          }
        } @else {
          <ng-content select="[cads-main-footer]"></ng-content>
        }
      </div>
    </div>
  </footer>
</article>
